import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root',
})
export class StoresService {
  private url = environment.urlBackend;

  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService
  ) {}

  public getStores() {
    this.spinnerService.showSpinner();
    return this.http.get(this.url + 'stores').pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }
}
